import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetColors } from 'domains/Color/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../CustomerProfileFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const ColorFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [colors] = useGetColors()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'colors',
    operand: 'array-contains'
  })

  return (
    <StyledDetails
      open={localStorage.getItem(`color-details-visibility`) === 'opened'}>
      <summary style={summaryStyles} onClick={() => onToggleDetails('color')}>
        {t('Color')}
      </summary>
      {colors?.map((color, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(color)}
            onChange={() => onChange(color)}>
            <Text wordBreak="break-all">
              {color?.hex || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

ColorFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default ColorFilter
